import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function formatINR(amount) {
  if (amount === null || amount === undefined) return "";
  return `₹${Number(amount).toLocaleString("en-IN")}`;
}

export const STATUS_LABELS = {
  new: "New",
  picked_up: "Picked up",
  paid: "Paid",
  cancelled: "Cancelled",
};

export const STATUS_STYLES = {
  new: "bg-blue-50 text-blue-800 border-blue-200",
  picked_up: "bg-blue-50 text-[#1e429f] border-blue-200",
  paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
  cancelled: "bg-red-50 text-red-700 border-red-200",
};

export const ISSUE_OPTIONS = [
  { value: "front_camera", label: "Front camera not working" },
  { value: "back_camera", label: "Back camera not working" },
  { value: "volume_button", label: "Volume button not working" },
  { value: "power_button", label: "Power button not working" },
  { value: "speaker", label: "Speaker not working" },
  { value: "microphone", label: "Microphone not working" },
  { value: "charging_port", label: "Charging port faulty" },
  { value: "wifi_bluetooth", label: "WiFi / Bluetooth not working" },
  { value: "fingerprint_faceid", label: "Fingerprint / Face ID not working" },
  { value: "no_network", label: "No network / SIM not detected" },
  { value: "touch_not_working", label: "Touch not working properly" },
];

export const issueLabel = (v) =>
  ISSUE_OPTIONS.find((o) => o.value === v)?.label || "No problems";

export const issuesText = (c) => {
  if (c.working === "yes") return "fully working";
  if (c.working === "no") return c.issues?.length ? c.issues.map(issueLabel).join(", ") : "not fully working";
  return c.issues?.length ? c.issues.map(issueLabel).join(", ") : "No problems";
};

